import React from "react";
import LegalLayout from "./LegalLayout";

export default function PoliticaPrivacidadPage() {
  return (
    <LegalLayout title="Política de privacidad" testid="politica-privacidad-page">
      <h2>Responsable del tratamiento</h2>
      <p>
        Santiago Lorenzo Garrido — NIF 34986749T — Calle Méjico 4, 24193 Navatejera (León),
        España — <a href="mailto:santilorenzogar@gmail.com">santilorenzogar@gmail.com</a>.
      </p>

      <h2>Qué datos tratamos</h2>
      <ul>
        <li>
          Datos identificativos y de contacto que nos facilitas en formularios, al escribirnos
          por WhatsApp o email, o al reservar una llamada: nombre, email, teléfono, país y la
          información que decidas compartir sobre tu situación.
        </li>
        <li>Datos de compra, cuando adquieres un programa (gestionados por Hotmart).</li>
        <li>
          Datos de navegación, mediante cookies, solo si las aceptas (ver{" "}
          <a href="/politica-de-cookies">Política de Cookies</a>).
        </li>
      </ul>

      <h2>Para qué los usamos y con qué base legal</h2>
      <div className="legal-table-wrap">
        <table className="legal-table">
          <thead>
            <tr>
              <th>Finalidad</th>
              <th>Base legal</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Responder a tus consultas y solicitudes de información</td>
              <td>Tu consentimiento y la aplicación de medidas precontractuales</td>
            </tr>
            <tr>
              <td>Gestionar la reserva de llamadas y sesiones</td>
              <td>Ejecución de un contrato o medidas precontractuales</td>
            </tr>
            <tr>
              <td>Prestar los servicios contratados (mentorías, sesiones, formaciones)</td>
              <td>Ejecución del contrato</td>
            </tr>
            <tr>
              <td>Emitir facturas y cumplir obligaciones fiscales</td>
              <td>Obligación legal</td>
            </tr>
            <tr>
              <td>
                Enviarte comunicaciones, contenidos y novedades (lista de espera, newsletter,
                canal)
              </td>
              <td>Tu consentimiento, que puedes retirar en cualquier momento</td>
            </tr>
            <tr>
              <td>Medir y mejorar la web y las campañas (analítica y píxel de Meta)</td>
              <td>Tu consentimiento mediante el banner de cookies</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2>Datos sensibles</h2>
      <p>
        Te pedimos que no incluyas en formularios información de salud. Si durante una sesión
        compartes voluntariamente información de este tipo, se tratará con confidencialidad,
        solo para prestar el servicio y sobre la base de tu consentimiento explícito.
      </p>

      <h2>Cuánto tiempo los conservamos</h2>
      <p>
        Mientras dure la relación y, después, durante los plazos legales (por ejemplo, 6 años
        para documentación contable y fiscal). Los datos de comunicaciones comerciales, hasta
        que retires tu consentimiento.
      </p>

      <h2>Con quién los compartimos</h2>
      <p>
        No vendemos tus datos. Pueden acceder a ellos, como encargados del tratamiento, los
        proveedores necesarios para prestar el servicio:
      </p>
      <ul>
        <li>Hotmart (pagos y acceso a programas)</li>
        <li>Calendly (reserva de llamadas)</li>
        <li>Meta Platforms (WhatsApp, y el píxel de Meta si aceptas cookies)</li>
        <li>Zoom (sesiones online)</li>
        <li>MailerLite (envío de emails)</li>
        <li>Emergent y su proveedor de alojamiento (hosting de la web)</li>
        <li>Google (Search Console y, en su caso, analítica)</li>
        <li>Asesoría fiscal, para obligaciones legales</li>
      </ul>
      <p>
        Algunos de estos proveedores están fuera del Espacio Económico Europeo (principalmente
        EE. UU.). En esos casos, las transferencias se amparan en el Marco de Privacidad de
        Datos UE-EE. UU. o en cláusulas contractuales tipo aprobadas por la Comisión Europea.
      </p>

      <h2>Tus derechos</h2>
      <p>
        Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación
        del tratamiento y portabilidad, y retirar tu consentimiento en cualquier momento,
        escribiendo a{" "}
        <a href="mailto:santilorenzogar@gmail.com">santilorenzogar@gmail.com</a> con el asunto
        “Protección de datos”. Si consideras que no hemos atendido correctamente tu
        solicitud, puedes presentar una reclamación ante la Agencia Española de Protección de
        Datos (
        <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">
          www.aepd.es
        </a>
        ).
      </p>

      <h2>Menores</h2>
      <p>Los servicios están dirigidos a mayores de 18 años.</p>

      <h2>Seguridad</h2>
      <p>
        Aplicamos medidas técnicas y organizativas razonables para proteger tus datos frente a
        pérdida, uso indebido o acceso no autorizado.
      </p>
    </LegalLayout>
  );
}
